import BootstrapVue from 'bootstrap-vue';
import * as VueGoogleMaps from 'vue2-google-maps';

import Vue from 'vue';
import VueCookie from 'vue-cookie';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import './assets/css/app.scss';

import App from './App.vue';
import router from './router';
import store from './store';
import DateHelper from './helpers/Date';

if (!('scrollBehavior' in document.documentElement.style)) {
  import('scroll-behavior-polyfill');
}

Vue.config.productionTip = process.env.NODE_ENV === 'development';

Vue.use(VueCookie);
Vue.use(BootstrapVue);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyC7FR2Oho80I2u284pCezLkMtTTaXoUKYo',
    libraries: 'places',
    language: 'en',
  },
});

Vue.filter('date', date => DateHelper.format(date));

new Vue({
  router,
  store,
  render: h => h(App),
  data() {
    return {
      width: window.innerWidth,
      resizeTimeout: null,
    };
  },
  computed: {
    isMobile() {
      return this.width <= 990;
    },
    isDesktop() {
      return !this.isMobile;
    },
  },
  methods: {
    setWindowWidth() {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => {
        this.width = window.innerWidth;
      }, 200);
    },
    getWebsiteUrl(path = '') {
      return `${process.env.VUE_APP_WEBSITE_PROTO}://${process.env.VUE_APP_WEBSITE_DOMAIN}/${path}`;
    },
    getProfilePictureUrl(handle) {
      const trimmedHandle = String(handle).trim();

      return `${process.env.VUE_APP_CLOUDINARY_URL}/image/instagram_name/${trimmedHandle}.jpg`;
    },
  },
  mounted() {
    window.onresize = this.setWindowWidth;
  },
}).$mount('#app');
